<template>
  <v-card>
    <v-toolbar color="white" flat>
        <v-toolbar-title class="mx-4">Danh sách phòng ban</v-toolbar-title>
        <v-spacer></v-spacer>
        
        <help-dialog></help-dialog>
        <v-menu
            left
            bottom offset-y
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn outlined color="success" class="ml-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    Hành động<v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </template>

            <v-list>
            <v-list-item @click="ipDialog=true">
                <v-list-item-icon>
                  <v-icon color="primary" right>mdi-plus</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Thêm phiếu </v-list-item-title>
            </v-list-item>
            </v-list>
        </v-menu>
    </v-toolbar>
    <v-card-text>
      <v-text-field block outlined dense hide-details prepend-inner-icon="mdi-magnify" v-model="search" placeholder="Tìm kiếm"></v-text-field>
      <v-data-table 
        :items="departments"
        :headers="headers"
        :search="search"
        :sort-desc="['deptType']"
        @contextmenu:row.prevent="rowRightClickHandler"
      >
      </v-data-table>

      <!-- right click menu -->
      <r-click-menu :showMenu="rClickMenu" :x="rClickMenuX" :y="rClickMenuY" @open-ip-dialog="openIpDialogHandler" @close-rclick-menu="rClickMenu=false"></r-click-menu>
      <ip-dialog :show="ipDialog" :form="formIp" :ipList="ipList" :selectItem="selectItem" @close="ipDialog=false"></ip-dialog>

    </v-card-text>
  </v-card>
</template>

<script>
import DepartmentService from '../../services/DepartmentService'
import HelpDialog from './HelpDialog.vue'
import RClickMenu from './RClickMenu.vue'
import IpDialog from './IpDialog.vue'
export default {
  components:{
    HelpDialog,
    RClickMenu,
    IpDialog
  },

  departmentService: null,
  data() {
    return {
      departments: [],
      selectItem: {},
      search: "",
      headers: [
        {text: 'Mã', value: 'code'},
        {text: 'Phân loại', value: 'deptType'},
        {text: 'Tên', value: 'name'},
        {text: 'Ngày khai trương', value: 'launchDate'},
        {text: 'Quản lý vùng', value: 'asm'},
        {text: 'Mã vùng', value: 'cityCode'},
        {text: 'Vùng', value: 'city'},
      ],

      // menu and dialog
      rClickMenu: false,
      rClickMenuX: 0,
      rClickMenuY: 0,

      //dialog IP
      ipDialog: false,
      ipList: '',
      formIp: {
        ip1: '',
        ip2: '',
        ip3: ''
      },



    }
  },
  methods: {
    rowRightClickHandler(e, select) {
      this.rClickMenuX = e.clientX
      this.rClickMenuY = e.clientY
      this.rClickMenu = true
      this.selectItem = select.item
    },

    openIpDialogHandler() {
      this.ipDialog = true
      this.departmentService.getDeptIp(this.selectItem.code).then(d => {
        this.ipList = d
        let ipArr = this.ipList.split(',')
        this.formIp.ip1 = ipArr[0]
        this.formIp.ip2 = ipArr[1]
        this.formIp.ip3 = ipArr[2]
      })
    },

    closeIpDialogHandler() {
      this.selectItem = {}
      this.ipDialog = false
    },
  },

  created() {
    this.departmentService = new DepartmentService();
  },
  mounted() {
    this.departmentService.gets().then(d => this.departments=d)
  }
  
}
</script>